if (!customElements.get(`swym-wishlist`)) {
  class SwymWishlist extends HTMLElement {
    constructor() {
      super();
    }

    renderItems() {
      const wishlist_products = this.querySelector(`[data-wishlist-products]`);
      const wishlist_count = this.querySelector(`[data-wishlist-count]`);
      const no_products = this.querySelector(`[data-no-products]`);
      const top_sign_in = this.querySelector('[data-top-sign-in]');

      no_products.classList.add(`hidden`);

      if (wishlist_items.length === 0) {
        wishlist_count.innerHTML = ``;
        this.classList.add(`items-center`);
        top_sign_in?.classList.add(`hidden`);
        wishlist_products.classList.add(`hidden`);
        no_products.classList.remove(`hidden`);
        return;
      }

      this.classList.remove(`items-center`);
      top_sign_in?.classList.remove(`hidden`);
      wishlist_products.classList.remove(`hidden`);
      wishlist_products.innerHTML = ``;

      wishlist_items.forEach(item => {
        const product_handle = item.du.split(`products/`)[1];
        wishlist_products.insertAdjacentHTML( // intersection-loader from intersection-loader.js
          `beforeend`,
          `<intersection-loader 
            data-url="/products/${product_handle}"
            data-section-id="product-tile"
            data-extra="variant-id:${item.epi}"
          ></intersection-loader>`)
      });

      wishlist_count.innerHTML = ` (${wishlist_items.length})`;
    }

    init() {
      this.renderItems();

      document.addEventListener(`wishlist-items-updated`, () => {
        this.renderItems();
      });
    }

    connectedCallback() {
      poll(() => {
        return wishlist_items;
      }, 10000, 150).then(() => {
        this.init();
      });
    }
  }  
  customElements.define(`swym-wishlist`, SwymWishlist);
}